import type { ComponentProps } from "react";

type Props = ComponentProps<"svg"> & {
  bodyClassName?: string | undefined;
  tireClassName?: string | undefined;
  flagBackgroundClassName?: string | undefined;
  flagForegroundClassName?: string | undefined;
};

function LogoIcon({
  bodyClassName,
  tireClassName,
  flagBackgroundClassName,
  flagForegroundClassName,
  ...props
}: Props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 520 355" {...props}>
      <path
        fill="#010101"
        fillRule="evenodd"
        d="M67 0h244a10 10 0 0 1 10 10v250h13V65a10 10 0 0 1 10-10h111a16 16 0 0 1 15 9l45 88a41 41 0 0 1 5 19v124a10 10 0 0 1-10 10h-23c-6 0-10-4-12-10-4-14-15-37-47-41h-20c-32 4-44 28-48 41-2 6-7 10-12 10H197c-6 0-10-5-12-10-3-14-14-37-48-41h-20c-33 4-44 27-48 41-1 5-6 10-11 10H10a10 10 0 0 1-10-10v-25a10 10 0 0 1 10-10h5V10A10 10 0 0 1 25 0h22zm320 84h44a15 15 0 0 1 14 9l25 59a7 7 0 0 1-6 9h-77a10 10 0 0 1-10-10V94a10 10 0 0 1 10-10z"
        className={bodyClassName}
      />
      <path
        stroke="#d8221c"
        strokeWidth="176"
        d="M75 134h189"
        className={flagBackgroundClassName}
      />
      <path
        stroke="#fff"
        strokeWidth="38"
        d="M112 128h114m-57-57v114"
        className={flagForegroundClassName}
      />
      {[128, 419].map((value, index) => (
        <circle
          key={index}
          cx={value}
          cy="311"
          r="32"
          fill="none"
          stroke="#000"
          strokeWidth="24"
          className={tireClassName}
        />
      ))}
    </svg>
  );
}

export { LogoIcon };
